import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DIAM_API_PATH, DIAM_TEAM_ID, deleteTeamRole } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useDeleteTeamRole() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (roleId: string) => {
      const idToken = await getIdToken();
      return deleteTeamRole(apiUrl, idToken, roleId);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['diam', 'teams', DIAM_TEAM_ID, 'roles', 'page'],
      });
    },
  });
}
